import { BaseEntryScope } from '#packages/apilib';
import {
  EditorAPIKey,
  WorkspaceApiKey,
  CompPointersApiKey,
} from '#packages/apis';

import { ResizeGapsStore } from './resizeGapsStore';

export class ResizeGapsScope extends BaseEntryScope {
  workspace = this.useDependency(WorkspaceApiKey);
  editorAPI = this.useDependency(EditorAPIKey);
  compPointersApi = this.useDependency(CompPointersApiKey);

  resizeGapsStore = this.declareStore(ResizeGapsStore);
}
